import * as T from "@src/types"
import { ViewTypes } from "@src/types"
import { isInvalidHost } from "@src/Utils"
import * as React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"

interface IPrivateRoute {
  component: React.ElementType
  isAuthenticated: boolean
  companyProfile: T.tCompanyProfile
  webDomain: string
}

export const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  location,
  companyProfile,
  webDomain,
  ...rest
}: IPrivateRoute & RouteProps) => {
  if (!isAuthenticated) {
    const redirectUrl = window.location.href
    const pathname = window.location.pathname

    if (pathname !== "/") {
      document.cookie = `redirectURL=${redirectUrl}; path=/`
    }

    return (
      <Redirect
        to={{ pathname: ViewTypes.signin, state: { from: location } }}
      />
    )
  }

  if (isInvalidHost(webDomain)) {
    return (
      <Redirect
        to={{ pathname: ViewTypes.incorrectURL, state: { from: location } }}
      />
    )
  }

  if (!companyProfile) {
    return (
      <Redirect
        to={{ pathname: ViewTypes.onboarding, state: { from: location } }}
      />
    )
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />
}
